<div class="flucelvax">
  @if (!userLoggedIn) {
    <div class="breadcrumbs--page-nav hidden-xs hidden-sm d-none d-lg-block">
      <div class="container">
        <p>
          <a routerLink="/">{{"statictext.home" | cxTranslate}}</a>
          <span> &gt; </span>
          <a routerLink="/products">{{"statictext.products" | cxTranslate}}</a>
          <span> &gt; </span><strong>{{"statictext.flucelvax" | cxTranslate}}</strong>
        </p>
      </div>
    </div>
  }
  @if (bannernode |async; as item) {
    <div class="product_box1">
      <div class="product_box1-container ">
        <div class="product_box1-text ">{{item.headLine}}</div>
        <div class="product_box1-content">
          <div  class="product-content" [innerHTML]="item.content"></div>
          <!-- <a class="button" href="/products/flucelvax/the-cell-based-solution" class="product_box2-button">See the Cell-Based
        Difference</a> -->
        <a class="button product_box2-button" [routerLink]="item.linkUrl" [innerHTML]="item.linkName"></a>
      </div>
      <div class="clearboth"></div>
      <div class="product_box1-text2-gray " [innerHTML]="item.text1content"></div>
      <div class="product_box1-disclaimer " [innerHTML]="item.text2content"></div>
    </div>
  </div>
}
</div>

<div class="fluad">
  @if (bannernode |async; as item) {
    <div class="product_box1">
      <div class="container">
        <div class="product_box1-container ">
          <div class="product_box1-text ">{{item.headLine}}</div>
          <div class="product_box1-content">
            <div [innerHTML]="item.content"></div>
            <a [routerLink]="item.linkUrl" class="product_box1-button">{{item.linkName}}</a>
          </div>
          <div class="clearboth"></div>
        </div>
      </div>
    </div>
  }
</div>